import React from "react";
import { useRoleSettings } from "@/hooks/use-role-settings";

export function HasSetting({ setting, fallback = null, children }) {
  // Pasa un STRING, no un array, para deps estables
  const { loading, hasSetting } = useRoleSettings(setting);

  if (loading && !hasSetting(setting)) return null;
  return hasSetting(setting) ? <>{children}</> : <>{fallback}</>;
}